// @flow

import React from "react";
import { localize } from "redux-i18n";
import classNames from "classnames";

type Props = $Exact<{
  ...PropsFromLocalize,
  notices: string[],
  wrapperClassName?: string,
}>;

const SecurityNotice = ({ notices, wrapperClassName, t }: Props) => (
  <div className={classNames("w-100 d-flex align-items-center", wrapperClassName)}>
    <span className="material-icons font-size-100">lock</span>
    <div className="fs-16 ml-2">
      {notices.map(el => (
        <p className="m-0" key={el}>
          {t(el)}
        </p>
      ))}
    </div>
  </div>
);

export default localize()(SecurityNotice);
